import { render, staticRenderFns } from "./AddAliasForm.vue?vue&type=template&id=5a330386"
import script from "./AddAliasForm.vue?vue&type=script&lang=js"
export * from "./AddAliasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports